<div class="app-container">
  <public-header [providerPracticeState]="providerShareableProfile?.practice_state?.abbrev"></public-header>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isValid; else notFound">
      <main class="main-content">
        <landing-page-header
          *ngIf="providerShareableProfile"
          [providerShareableProfile]="providerShareableProfile"
          [paramsShareCode]="paramsShareCode"
          [paramsName]="paramsName"
          [requestSessionQueryParams]="requestSessionQueryParams"
          [useCheckoutFormFf]="(useCheckoutFormFf$ | async)"
          [showRedesignFf]="(pslRedesignFf$ | async).showRedesign"
          [alwaysShowAcceptingFf]="(alwaysShowAcceptingFf$ | async)"
          (requestASessionClicked)="onRequestSessionButtonClicked($event)"
        ></landing-page-header>
        <div class="actions" *ngIf="(pslRedesignFf$ | async)?.showRedesign">
          <connect-card
            [firstName]="providerShareableProfile?.display_first_name"
            [ctaButtonText]="(pslRedesignFf$ | async)?.ctaButtonText"
            [paramsShareCode]="paramsShareCode"
            [paramsName]="paramsName"
            [requestSessionQueryParams]="requestSessionQueryParams"
            [soonestAvailableDate]="soonestAvailableDate"
            [useCheckoutFormFf]="(useCheckoutFormFf$ | async)"
            (requestASessionClicked)="onRequestSessionButtonClicked($event)"
          ></connect-card>
        </div>
    
        <provider-details
          [providerShareableProfile]="providerShareableProfile"
          [showRedesign]="(pslRedesignFf$ | async)?.showRedesign"
        >
        </provider-details>

        <!-- Footer is contained within main to have body + footer be scrollable together -->
        <footer >
          <public-footer 
            [currentStateAbbrev]="providerShareableProfile?.practice_state?.abbrev || null" 
            [matchflowBaseUrl]="therapyMatchFlowUrl">
          </public-footer>
        </footer>
      </main>

      <div class="mobile-bottom-drawer" *ngIf="providerShareableProfile.accepting_clients || (alwaysShowAcceptingFf$ | async)">
        <iris-button-container>
          <iris-button
            *ngIf="(useCheckoutFormFf$ | async); else linkToFlow"
            (click)="onRequestSessionButtonClicked(false)"
            class="request-session-button"
          >
            Request a session
          </iris-button>
        <ng-template #linkToFlow>
          <iris-button
            [routerLink]="['/match', paramsShareCode, paramsName]"
            [queryParams]="requestSessionQueryParams"
            class="request-session-button"
            tabindex="0"
            (click)="onRequestSessionButtonClicked(true)"
          >
            Request a session
          </iris-button>
        </ng-template>
        </iris-button-container>
        <span class="support-phone-number">
          Need support? Call <a href="tel:{{ supportPhoneNumberLink }}">{{supportPhoneNumberDisplay}}</a>
        </span>
      </div>
    </ng-container>
  </ng-container>
</div>
  
<ng-template #notFound>
  <div class="page-not-found-container">
    <page-not-found [therapyMatchFlowUrl]="therapyMatchFlowUrl"></page-not-found>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loader"></div>
</ng-template>
